let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6z7Lu")).then(() => parcelRequire('cqWnC'));